import React from "react";
import { BadgeDelta, Card, type DeltaType } from "@tremor/react";

interface StatCardProps {
  title: string;
  icon: React.ReactNode;
  value: string;
  /** Formatted value of the compared period, e.g. "45 872,00 zł". Null when there is nothing to compare with. */
  previousValue: string | null;
  /** Human label of the compared period, e.g. "1–4.08". */
  comparisonLabel: string;
  /** Change against the compared period; the unit says whether it is relative ("%") or in percentage points ("p.p."). */
  change: number | null;
  changeUnit: "%" | "p.p.";
}

const getDeltaType = (change: number): DeltaType => {
  if (change === 0) {
    return "unchanged";
  }

  return change > 0 ? "increase" : "decrease";
};

export const StatCard = ({
  title,
  icon,
  value,
  previousValue,
  comparisonLabel,
  change,
  changeUnit,
}: StatCardProps): React.ReactElement => (
  <Card>
    <div className="flex flex-row items-center justify-between pb-2">
      <div className="text-sm font-medium">{title}</div>
      {icon}
    </div>
    <div className="text-2xl font-bold">{value}</div>
    {previousValue !== null ? (
      <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-tremor-content dark:text-dark-tremor-content">
        {change !== null ? (
          <BadgeDelta deltaType={getDeltaType(change)} size="xs">
            {change > 0 ? "+" : ""}
            {change}
            {changeUnit === "%" ? "%" : " p.p."}
          </BadgeDelta>
        ) : null}
        <span>
          {comparisonLabel}: <span className="tabular-nums">{previousValue}</span>
        </span>
      </div>
    ) : null}
  </Card>
);
